// src/api/pedidosApi.js
//
// Endpoints de pedidos. Todos requieren sesión (Bearer).

import { api } from './apiClient';

export const pedidos = {
  /**
   * Crea un pedido (rol VECI). El backend valida que:
   * - El VECI tenga sesión.
   * - El negocio (SucursalId) exista y esté activo.
   * - Los productos existan y estén activos.
   * - Cumpla políticas del método de pago (recibir | qr | fiado_solicitud).
   */
  crear: (payload) => api.post('/api/holaveci/pedidos', payload),

  /**
   * Listar los pedidos según el rol (veci ve los suyos, negocio los de su
   * sucursal, domi los asignados). Filtro por estado y paginación.
   */
  listar: (params = {}) =>
    api.get('/api/holaveci/pedidos', { query: params }),

  detalle: (pedidoId) =>
    api.get(`/api/holaveci/pedidos/${pedidoId}`),

  cancelar: (pedidoId, motivo) =>
    api.post(`/api/holaveci/pedidos/${pedidoId}/cancelar`, { motivo }),

  esperar: (pedidoId) =>
    api.post(`/api/holaveci/pedidos/${pedidoId}/esperar`, {}),

  cambiarEstado: (pedidoId, estado) =>
    api.put(`/api/holaveci/pedidos/${pedidoId}/estado`, { estado }),

  asignarDomiciliario: (pedidoId, domiciliarioId) =>
    api.put(`/api/holaveci/pedidos/${pedidoId}/asignar-domiciliario`, { domiciliarioId }),

  /** Domiciliario reporta SOS con GPS. No cambia el estado del pedido. */
  sos: (pedidoId, payload) =>
    api.post(`/api/holaveci/pedidos/${pedidoId}/sos`, payload),

  verificarPago: (pedidoId, verificado) =>
    api.put(`/api/holaveci/pedidos/${pedidoId}/verificar-pago`, { verificado }),

  marcarEntregado: (pedidoId) =>
    api.post(`/api/holaveci/pedidos/${pedidoId}/marcar-entregado`, {}),

  activoConNegocio: (negocioId) =>
    api.get(`/api/holaveci/pedidos/activo-con-negocio/${negocioId}`),

  // Comentarios en pedido
  comentarios: (pedidoId) =>
    api.get(`/api/holaveci/pedidos/${pedidoId}/comentarios`),

  agregarComentario: (pedidoId, texto) =>
    api.post(`/api/holaveci/pedidos/${pedidoId}/comentarios`, { texto }),

  marcarComentariosLeidos: (pedidoId) =>
    api.post(`/api/holaveci/pedidos/${pedidoId}/comentarios/marcar-leidos`, {}),
};
